import { render, staticRenderFns } from "./SocialAuthBtns.vue?vue&type=template&id=0d8f1fc6&scoped=true"
import script from "./SocialAuthBtns.vue?vue&type=script&lang=js"
export * from "./SocialAuthBtns.vue?vue&type=script&lang=js"
import style0 from "./SocialAuthBtns.vue?vue&type=style&index=0&id=0d8f1fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8f1fc6",
  null
  
)

export default component.exports